import React, {useState, useEffect, useRef} from 'react';
import Config from './Config/ar'

import { useApp } from "../context/AppContext";
import Api from './Api'

const Footer = ({etat}) => {

    const { activity, element} = useApp();
    const [time, Time] = useState("");
    const lastRef = useRef(0);

    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
        ,hour: 'numeric'
        ,minute: 'numeric'
        //,second: 'numeric'
    }

    // MeR 260823 finally init timer
    useEffect(() => {
        const now = new Date()
        Time(now.toLocaleDateString('ar-MA', options))

        if(lastRef.current===0)
            lastRef.current = now.getMinutes()*60+now.getSeconds()

    },[])

    useEffect(() => {
    
        setTimeout(() => {
            const now = new Date()
            Time(now.toLocaleDateString('ar-MA', options))

            // MeR 260422 finally 
            if(element>0 && [2,4,7].includes(activity)) {
                const current = now.getMinutes()*60+now.getSeconds()
                const focusing = current-lastRef.current
                if(focusing<0)
                    lastRef.current = current
                //etat = `last=${lastRef.current} current ${current} = focusing=${focusing}`
                if(focusing>=7*7) {
                    Api.post(`Timer`, {
                        ActivityId: activity,
                        ElementId: element,
                        Focused: focusing
                    })
                    .then(res => {
                        //setFocused(current) // render issue so :
                        lastRef.current = current
                        //alert(JSON.stringify(res.data), `${time} focusing=${focusing}`)
                    })
                    .catch(err => {
                        //console.log(JSON.stringify(err))
                    })
                }
            }
            
        }, 7*7000)
        return () => { clearTimeout(time)}
    },[time])


    return (
        <div className="Footer">
            <i>{Config.title}</i>
            <i>{time}</i>
            <i>{etat?.length>0 ? etat : 'السلام عليكم'}</i>    
            <i>{element}-{activity}</i>
        </div>
    )
}

export default Footer;

